export const Stat = ({ l, v, sub, big, color, c }) => (
  <div>
    <div style={{ color: c.muted, fontSize: 11, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 6 }}>{l}</div>
    <div style={{ fontSize: big ? 48 : 26, fontWeight: 700, letterSpacing: "-0.035em", lineHeight: 1.1, color: color || c.fg }}>{v}</div>
    {sub && <div style={{ color: c.muted, fontSize: 13, marginTop: 6, lineHeight: 1.4 }}>{sub}</div>}
  </div>
);
